import { render, staticRenderFns } from "./HeaderPanel.vue?vue&type=template&id=efb21dd4&scoped=true&"
import script from "./HeaderPanel.vue?vue&type=script&lang=js&"
export * from "./HeaderPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb21dd4",
  null
  
)

export default component.exports